import { parseAsStringLiteral } from "nuqs"
import { VALID_PLANS } from "./(components)/constants"

export const planItemParser = parseAsStringLiteral(VALID_PLANS).withDefault("team")
